import { Table, Row, ColumnDef } from "@tanstack/react-table";

import { Checkbox } from "../checkbox";
import { Skeleton } from "../skeleton";

export const SELECTION_COLUMN_ID = "row-selection";

export const CellSkeleton = () => {
  const baseStyles = "block rounded w-3/4 h-3/4 overflow-hidden";

  return (
    <span className={baseStyles}>
      <Skeleton />
    </span>
  );
};

type HeaderCheckboxProps<T> = {
  table: Table<T>;
};

export const HeaderCheckbox = <T extends {}>({
  table,
}: HeaderCheckboxProps<T>) => (
  <div className="h-full flex justify-center items-center">
    <Checkbox
      indeterminate={table.getIsSomeRowsSelected()}
      checked={table.getIsAllRowsSelected()}
      onEventChange={table.getToggleAllRowsSelectedHandler()}
    />
  </div>
);

type CellCheckboxProps<T> = {
  row: Row<T>;
};

export const CellCheckbox = <T extends {}>({ row }: CellCheckboxProps<T>) => (
  <div className="h-full flex justify-center items-center">
    <Checkbox
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onChange={row.getToggleSelectedHandler()}
      stopPropagation
    />
  </div>
);

export const createSelectionColumn = <T extends {}>(): ColumnDef<T> => ({
  id: SELECTION_COLUMN_ID,
  header: ({ table }) => <HeaderCheckbox table={table} />,
  cell: ({ row }) => <CellCheckbox row={row} />,
  meta: {
    action: true,
  },
});
